import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 18.99h11c.67 0 1.27-.32 1.63-.83L21 12l-4.37-6.16C16.27 5.33 15.67 5 15 5H4l5 7-5 6.99z"
}), 'LabelImportantOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LabelImportantOutlined.js
// module id = 4377
// module chunks = 2